import { useRef } from 'react'
import useStyles from './Content.styled'

export const useContent = props => {
	const { classes, cx } = useStyles(props, { props })
	const sortHandlerParentRef = useRef()

	return [
		{
			...props,
			withImage: !!props.image,
			classes,
			cx,
			sortHandlerParentRef,
		},
	]
}
